import React, { FC, MouseEventHandler } from "react";
import styled from "styled-components";
import Button, { Variants } from "ui/components/Button/Button";

const StyledSectionTitle = styled.h2`
    font-size: ${(props) => props.theme.typography.heading.normal.fontSize};
    line-height: ${(props) => props.theme.typography.heading.normal.lineHeight};
    font-weight: ${(props) => props.theme.typography.heading.normal.fontWeight};
    color: ${(props) => props.theme.colors.neutral.neutral800};
`;

const Paragraph = styled.p`
    max-width: 600px;
    margin: ${(props) => props.theme.spacing.md} 0;
    font-size: ${(props) => props.theme.typography.body.normal.fontSize};
    line-height: ${(props) => props.theme.typography.body.normal.lineHeight};
    font-weight: ${(props) => props.theme.typography.body.normal.fontWeight};
    color: ${(props) => props.theme.colors.neutral.neutral400};
`;

const ButtonWrapper = styled.div`
    display: flex;
    gap: ${(props) => props.theme.spacing.sm};
    max-width: 600px;
    margin-bottom: ${(props) => props.theme.spacing.md};
`;

const StyledSection = styled.section`
    border-bottom: 1px solid ${(props) => props.theme.colors.neutral.neutral200};
    margin-bottom: ${(props) => props.theme.spacing.md};
`;

interface IProps {
    buttonText?: string;
    secondButtonText?: string;
    buttonTestId?: string;
    secondButtonTestId?: string;
    onButtonClick?: MouseEventHandler<HTMLButtonElement>;
    onSecondButtonClick?: MouseEventHandler<HTMLButtonElement>;
    paragraphText: string;
    titleText: string;
}

const HelpSectionDouble: FC<IProps> = ({
    buttonText,
    buttonTestId,
    onButtonClick,
    secondButtonText,
    secondButtonTestId,
    onSecondButtonClick,
    paragraphText,
    titleText,
}) => {
    return (
        <StyledSection>
            <StyledSectionTitle>{titleText}</StyledSectionTitle>
            <Paragraph>{paragraphText}</Paragraph>
            <ButtonWrapper>
                {!!buttonText && !!onButtonClick && (
                    <Button
                        variant={Variants.SOLID}
                        color="secondary"
                        size="md"
                        fullWidth
                        type="button"
                        onClick={onButtonClick}
                        data-testid={buttonTestId}
                    >
                        {buttonText}
                    </Button>
                )}
                {!!secondButtonText && !!onSecondButtonClick && (
                    <Button
                        variant={Variants.SOLID}
                        color="secondary"
                        size="md"
                        fullWidth
                        type="button"
                        onClick={onSecondButtonClick}
                        data-testid={secondButtonTestId}
                    >
                        {secondButtonText}
                    </Button>
                )}
            </ButtonWrapper>
        </StyledSection>
    );
};

export default HelpSectionDouble;
